/**
 * Large UPS step — Additional Information visibility and attachment sections (#1330 / #997).
 * Standalone Large UPS scope does not require Facility Power to be enabled.
 */

import { resolveFacilityPowerAdditionalAttachmentsForStep } from './facilityPowerAdditionalInformation';

import type { SavedAttachment } from '../services/attachmentService';

function normalizeEnabledStepIds(
  enabledStepIds: readonly string[] | null | undefined,
): readonly string[] {
  return Array.isArray(enabledStepIds) ? enabledStepIds : [];
}

export function isLargeUpsStepEnabled(
  enabledStepIds: readonly string[] | null | undefined,
): boolean {
  return normalizeEnabledStepIds(enabledStepIds).includes('large-ups');
}

export function isFacilityPowerStepEnabled(
  enabledStepIds: readonly string[] | null | undefined,
): boolean {
  return normalizeEnabledStepIds(enabledStepIds).includes('facility-power');
}

export function resolveLargeUpsAdditionalAttachmentsForStep(
  attachmentsBySection:
    | Record<string, SavedAttachment[] | undefined>
    | null
    | undefined,
): SavedAttachment[] {
  return resolveFacilityPowerAdditionalAttachmentsForStep(
    'large-ups',
    attachmentsBySection,
  );
}

/** Unit editor — Large UPS step owns shared notes whenever the step is scoped (#1154 / #997). */
export function shouldShowLargeUpsAdditionalInformationInUnitEditor(options: {
  enabledStepIds: readonly string[] | null | undefined;
}): boolean {
  return isLargeUpsStepEnabled(options.enabledStepIds);
}

/** Step shell — repeating-section steps render Additional Information only in the unit editor. */
export function shouldShowLargeUpsAdditionalInformationAtStepLevel(_options: {
  enabledStepIds: readonly string[] | null | undefined;
}): boolean {
  return false;
}
